var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1NoPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 0h-5.65L0 70.34V76l18-18h46.94V23H53L76 0zM54 28h6v4h-6v-4zM38 52a12 12 0 01-9.42-4.58l16.84-16.84A12 12 0 0138 52zM26.08 38.69L11 53.76V23h11.91L31 15h14l2.38 2.38-10.69 10.69a12 12 0 00-10.61 10.62z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_No_Photo.80b77622.svg";
export { SvgH1NoPhoto as ReactComponent };